import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { contactInfo } from '@/mock';

const ContactInfo = () => {
  return (
    <div className="lg:col-span-2 space-y-6">
      {/* Phone */}
      <div className="p-6 rounded-2xl bg-gradient-to-br from-rose-900/10 to-transparent border border-rose-900/20">
        <div className="flex items-center space-x-4 mb-3">
          <div className="p-3 rounded-full bg-rose-200/10 border border-rose-200/30">
            <Phone className="w-5 h-5 text-rose-200" />
          </div>
          <div>
            <p className="text-rose-200 text-sm tracking-wider">TÉLÉPHONE</p>
          </div>
        </div>
        <a
          href={`tel:${contactInfo.phoneFormatted}`}
          className="text-2xl font-light text-white hover:text-rose-200 transition-colors"
        >
          {contactInfo.phone}
        </a>
        <p className="text-gray-400 text-sm mt-2">Appel & SMS</p>
      </div>

      {/* WhatsApp */}
      <div className="p-6 rounded-2xl bg-gradient-to-br from-rose-900/10 to-transparent border border-rose-900/20">
        <div className="flex items-center space-x-4 mb-3">
          <div className="p-3 rounded-full bg-rose-200/10 border border-rose-200/30">
            <FaWhatsapp className="w-5 h-5 text-rose-200" />
          </div>
          <div>
            <p className="text-rose-200 text-sm tracking-wider">WHATSAPP</p>
          </div>
        </div>
        <a
          href={`https://wa.me/${contactInfo.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-2xl font-light text-white hover:text-rose-200 transition-colors"
        >
          {contactInfo.phone}
        </a>
        <p className="text-gray-400 text-sm mt-2">Message rapide</p>
      </div>

      {/* Email */}
      <div className="p-6 rounded-2xl bg-gradient-to-br from-rose-900/10 to-transparent border border-rose-900/20">
        <div className="flex items-center space-x-4 mb-3">
          <div className="p-3 rounded-full bg-rose-200/10 border border-rose-200/30">
            <Mail className="w-5 h-5 text-rose-200" />
          </div>
          <div>
            <p className="text-rose-200 text-sm tracking-wider">EMAIL</p>
          </div>
        </div>
        <a
          href={`mailto:${contactInfo.email}`}
          className="text-xl font-light text-white hover:text-rose-200 transition-colors break-all"
        >
          {contactInfo.email}
        </a>
      </div>

      {/* Zone */}
      <div className="p-6 rounded-2xl bg-gradient-to-br from-rose-900/10 to-transparent border border-rose-900/20">
        <div className="flex items-center space-x-4 mb-3">
          <div className="p-3 rounded-full bg-rose-200/10 border border-rose-200/30">
            <MapPin className="w-5 h-5 text-rose-200" />
          </div>
          <div>
            <p className="text-rose-200 text-sm tracking-wider">ZONE</p>
          </div>
        </div>
        <p className="text-lg font-light text-white">{contactInfo.zone}</p>
        <p className="text-gray-400 text-sm mt-2">{contactInfo.zoneDetails}</p>
      </div>

      {/* Legal Info */}
      <div className="p-4 rounded-xl bg-black/30 border border-rose-900/10">
        <p className="text-gray-500 text-xs">
          Siren : {contactInfo.siren}<br />
          {contactInfo.company}
        </p>
      </div>
    </div>
  );
};

export default ContactInfo;
